<template>
  <form class="tranche-form flex-fJstart-fAcenter">
    <label class="flex-col-fJstart-fAstart">
      Libellé
      <input
        type="text"
        @input="e => setModalCache('libelle', e)"
      >
    </label>
    <label class="flex-col-fJstart-fAstart">
      À partir de...
      <div>
        <input
          type="text"
          @input="e => setModalCache('debut', e)"
        >
        <span class="unite">{{ typeUnite }}</span>
      </div>
    </label>
    <label class="flex-col-fJstart-fAcenter">
      Progressive
      <input
        v-model="trancheUnique"
        type="checkbox"
        @input="e => setModalCache('unique', e)"
        @click="toggleInterval()"
      >
    </label>
    <label
      v-if="trancheUnique"
      class="flex-col-fJstart-fAstart"
    >
      Interval
      <input
        type="text"
        @input="e => setModalCache('interval', e)"
      >
    </label>
  </form>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      trancheUnique: false
    }
  },
  computed: {
    ...mapGetters([
      'typeForfaitTransport'
    ]),
    typeUnite: function() {
      if (this.typeForfaitTransport === null) {
        return ''
      } else {
        return (this.typeForfaitTransport.typeForfait === 'poids') ? 'Kg' : '€'
      }
    }
  },
  created() {
    this.$store.dispatch('initTypeForfaitTransport')
  },
  methods: {
    toggleInterval() {
      this.trancheUnique = !this.trancheUnique
    },
    setModalCache(propname, { type, target }) {
      const { checked, value } = target
      const checkbox = target.type === 'checkbox'
      const cacheValue = checkbox ? checked : value
      this.$store.dispatch('setModalCache', ({ [propname]: cacheValue }))
    }
  }
}
</script>
<style scoped>
.tranche-form label {
  margin: 0 10px;
}
input[type=checkbox] {
  min-height: 30px;
  width: 20px;
  margin: 0;
}

.unite {
  margin-left: 1em;
}
</style>
